import { useNavigate } from "@tanstack/react-router";
import { useSession } from "./auth";

/**
 * Returns a function that initiates sign-in with proper test/prod behavior:
 * - Test auth enabled: Navigate to sign-in page (allows choosing auth method)
 * - Test auth disabled: Go directly to Google OAuth
 */
export function useSignInRedirect() {
  const { isTestAuthEnabled, signInWithGoogle } = useSession();
  const navigate = useNavigate();

  return (callbackUrl: string) => {
    if (isTestAuthEnabled) {
      sessionStorage.setItem("redirectAfterSignIn", callbackUrl);
      navigate({ to: "/auth/signin" });
    } else {
      signInWithGoogle(callbackUrl);
    }
  };
}
